module.exports = __webpack_public_path__ + "img/icon-add.8575b2fb.png";